import { TextAreaFormik } from '@strata/react-inputs';
import { AnnouncementsSection, HomeScreen } from '@strata/react-page-templates';
import { validationStrings } from '@strata/strata-ui-strings';
import dayjs from 'dayjs';
import * as Yup from 'yup';

import {
    ApplicationInputs,
    DisplayInput,
    EndDateInput,
    MessageCategoryInput,
    PublishDateInput,
} from 'pages/homeScreenMessaging/HomeScreenFormInputs';
import { HomeScreenMessageForm } from 'pages/homeScreenMessaging/HomeScreenMessageForm';

const formContent = () => (
    <>
        <MessageCategoryInput label="Announcement Type" />
        <TextAreaFormik id="message" label="Announcement" required />
        <ApplicationInputs />
        <PublishDateInput messageType={HomeScreen.MessageType.ANNOUNCE} />
        <EndDateInput messageType={HomeScreen.MessageType.ANNOUNCE} />
        <DisplayInput />
    </>
);

const previewContent = (values) => (
    <AnnouncementsSection
        announcements={[
            {
                publish_date: dayjs(values.publish_date || undefined).toISOString(),
                message: values.message || 'Announcement text.',
            },
        ]}
    />
);

export const AnnouncementDetails = () => (
    <HomeScreenMessageForm
        formTitle="Announcement"
        listPageUrl="/home-screen-messaging/announcements"
        formatInitialValues={(message) => ({
            ...MessageCategoryInput.initialValues(message),
            message: message?.message,
            ...ApplicationInputs.initialValues(message),
            ...PublishDateInput.initialValues(message),
            ...EndDateInput.initialValues(message),
            ...DisplayInput.initialValues(message),
        })}
        validationSchema={Yup.object({
            ...MessageCategoryInput.validationSchema,
            message: Yup.string().required(validationStrings.requiredField.errorMessage),
            ...ApplicationInputs.validationSchema,
            ...PublishDateInput.validationSchema,
            ...EndDateInput.validationSchema,
            ...DisplayInput.validationSchema,
        })}
        formatSubmitBody={(values) => ({
            message_type: HomeScreen.MessageType.ANNOUNCE,
            ...MessageCategoryInput.submitValues(values),
            message: values.message,
            ...ApplicationInputs.submitValues(values),
            ...PublishDateInput.submitValues(values),
            ...EndDateInput.submitValues(values),
            ...DisplayInput.submitValues(values),
        })}
        formContent={formContent}
        previewContent={previewContent}
    />
);
